import React, { useEffect, useState } from 'react'
import Graytextarea from '../../../src/components/Graytextarea'
import { CForm, CFormLabel, CFormTextarea, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { Plus } from 'lucide-react'
import Select from 'react-select'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { useIndexedDB } from '../../context/IndexedContext'
const ProviderRosTab = ({ noteStructureRef,patientID, isAllotedToProvider,rosAdded, setRosAdded, diagnosisName, showDataIfNoteIsFollowUp = true, setNoteRefTrigger , noteCallType }) => {
  const [value, setValue] = useState('')
  const [visible, setVisible] = useState(false)
  const [selectedReasons, setSelectedReasons] = useState([])
  const [text, setText] = useState("")
  const { getHPIDiagnosisData, getAllMasterDiagnosis, getOfflineData, saveOfflineData, getProviderDetails  , getOpenChartOfflineData , saveOpenChartOfflineData} = useIndexedDB()

  useEffect(() => {
    const reviewValue = noteStructureRef?.current?.reviewOfSystem?.editROS ?? "";
    const textValue = noteStructureRef?.current?.reviewOfSystem?.freeType || ''
    setValue(reviewValue);
    setText(textValue)
  }, []);

  console.log(noteStructureRef, value, 'noteStructureRef')
  const options = [
    {
      label: "14 pt ros was done and patient denies",
      value: "14 pt ros was done and patient denies",
    },
    {
      label: "Unable to obtain given clinical condition",
      value: "Unable to obtain given clinical condition",
    },

    {
      label: "As per HPI/Subjective",
      value: "As per HPI/Subjective",
    },
  ]

  // useEffect(() => {
  //     if(isAllotedToProvider){
  //           noteStructureRef.current = {
  //             ...noteStructureRef.current,
  //             reviewOfSystem: {
  //               ...noteStructureRef.current.reviewOfSystem,
  //               editROS : value
  //             }
  //           }
  //     }
  // }, [value]);

  const [isAddingRos, setIsAddingRos] = useState(false);
  const handleAddRosOffline = async(data) => {
    let offlineData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
    console.log(offlineData,'offlineData ros before ')
      let providerDetails = await getProviderDetails();
      console.log(offlineData,'offlineData')
      const providerId = providerDetails?.ID;
      console.log(providerId,'providerId',offlineData[providerId][patientID])
      offlineData[providerId][patientID].currentNote.data.reviewOfSystem = data
      console.log(offlineData,'offlineData ros after ')
      noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(offlineData)  : await saveOfflineData(offlineData)

  }
  const handleSubmit = async() => {
    setIsAddingRos(true)
    const joiningAllOption = (selectedReasons || [])?.map((option) => option.value).join("\n");
    const adminEditROS = noteStructureRef?.current?.reviewOfSystem?.editROS || "";
    // const joiningOptionWithText = adminEditROS + "\n" + joiningAllOption + "\n" + text 
    const joiningOptionWithText = joiningAllOption + "\n" + (text || "")
    console.log(joiningOptionWithText, 'joiningOptionWithText',)
    setValue(joiningOptionWithText)
    
    
    noteStructureRef.current = {
      ...noteStructureRef.current,
      reviewOfSystem: {
        ...noteStructureRef.current.reviewOfSystem,
        editROS: joiningOptionWithText,
        rosOption: (selectedReasons || [])?.map((option) => option.value),
        freeType: text
      }
    }
    await handleAddRosOffline({
        editROS: joiningOptionWithText,
        rosOption: (selectedReasons || [])?.map((option) => option.value),
        freeType: text
      })
    setText("")
    setSelectedReasons([])
    setIsAddingRos(false)
    toast.success("Review of system added successfully", toastConfig)
    setVisible(false)
    setRosAdded(p=>!p)
  }

  useEffect(() => {
    const fetchRos = async () => {
      let offlineIncidentData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
      let providerDetails = await getProviderDetails();
      console.log(offlineIncidentData, 'offlineIncidentData')
      const providerId = providerDetails?.ID;
      console.log(providerId, 'providerId', offlineIncidentData[providerId][patientID])
      let reviewOfSystem = offlineIncidentData?.[providerId]?.[patientID]?.currentNote?.data?.reviewOfSystem || {}
      // const reviewOfSystem = noteStructureRef.current.reviewOfSystem
      if (!reviewOfSystem) {
        return
      }
      setValue(reviewOfSystem?.editROS)
      setSelectedReasons(reviewOfSystem?.rosOption?.length > 0 && reviewOfSystem?.rosOption.map((option) => ({ label: option, value: option })))
      setText(reviewOfSystem?.freeType)
    }
    fetchRos()
  }, [visible])

  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role


  return (
    <>
      <div className="d-flex align-items-center gap-2">
        {/* <p class="m-0 p-0 font-weight-medium text-capitalize" style={{ fontSize: '1rem' }}>
                  Review Of System
                </p> */}
        {/* {isAllotedToProvider && <CFormLabel
                            className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setVisible((p) => !p)
                            }}
                            style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "20px",
                                background: "var(--ui-color-primary, #2b7cd3)",
                                cursor: "pointer",
                            }}
                        >
                            <Plus className="text-white" strokeWidth={2} size={15} />
                        </CFormLabel>} */}
      </div>

      <div>
        <CForm>
          <CFormTextarea
            height={400}
            placeholder="Click here to add Review of system"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setVisible((p) => !p)
              const reviewValue = noteStructureRef?.current?.reviewOfSystem?.editROS ?? "";
              console.log(reviewValue, 'reviewValue')
              setText(reviewValue || "")
            }}
            className="  rounded  mt-2"
            style={{
              height: "400px",
              backgroundColor: '#191919',
              color: 'white',
              border: '1px solid gray',
            }}
            rows={3}
            value={value}
            // onChange={(e) => {
            //     setValue(e.target.value)
            //     const reviewOfSystem = noteStructureRef?.current?.reviewOfSystem;
            //     if (
            //         reviewOfSystem &&
            //         reviewOfSystem.editROS &&
            //         reviewOfSystem.editROS !== e.target.value
            //     ) {
            //         reviewOfSystem.editROS = e.target.value;
            //     }
            // }}
            onChange={(e) => {
              const newValue = e.target.value
              setValue(newValue)

              const noteStructure = noteStructureRef?.current
              console.log(noteStructure)

              if (noteStructure) {
                if (typeof noteStructure.reviewOfSystem !== 'object' || noteStructure.reviewOfSystem === null) {
                  noteStructure.reviewOfSystem = {} // initialize if not an object
                }

                noteStructure.reviewOfSystem.editROS = newValue
              }
            }}
          />
        </CForm>
      </div>

      {/* <CModal size="lg" alignment="center" visible={visible} onClose={() => setVisible(false)} >
          <CModalHeader >
            <CModalTitle>Review of system</CModalTitle>
          </CModalHeader>
          <CModalBody
            className=" d-flex align-items-center justify-content-center"
            style={{
              minHeight: '300px',
            }}
          >
            <div className="w-75 d-flex flex-column" style={{ gap: '30px' }}>
              <div>
                <Select
                  value={selectedReasons}
                  isMulti
                  onChange={(e) => {
                    setSelectedReasons(e)
                  }}
                  placeholder="Select an reason"
                  options={options}
                />

                <div className='d-flex mt-2 gap-2 align-items-center'>
                                {Array.isArray(selectedReasons) && selectedReasons?.map((item, idx) => {
                                return(
                                    <div className='bg-warning p-2  rounded text-white' style={{width:"fit-content",fontSize:"10px"}}>{item.label}</div>
                                )
                            })}
                            </div>
              </div>
              <div>
                <p className="m-0 p-0">Freetype</p>
                <Graytextarea
                  value={text}
                  onChange={(e) => {
                    setText(e.target.value)
                  }}
                  height="100px"
                />
              </div>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton
              onClick={() => {
                setVisible(false)
                setSelectedReasons([])
                setText('')
              }}
              variant="outline"
              color="secondary"
            >
              Close
            </CButton>
            <CButton variant="outline" onClick={handleSubmit} color="primary">
              {isAddingRos ? 'Saving...' : 'Save'}{' '}
            </CButton>
          </CModalFooter>
        </CModal> */}

      <CModal size="lg" alignment="center" visible={visible} onClose={() => setVisible(false)} className="text-white">
        {/* Header */}
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            color: 'white',
            position: 'relative',
            borderRadius: '10px 10px 0 0',
          }}
        >
          <CModalTitle style={{ textAlign: 'center', color: 'white', width: '100%' }}>Review of System</CModalTitle>
        </CModalHeader>

        {/* Body */}
        <CModalBody
          className="d-flex align-items-center justify-content-center text-white"
          style={{
            minHeight: '300px',
            backgroundColor: '#282828',
          }}
        >
          <div className="w-75 d-flex flex-column" style={{ gap: '20px' }}>
            {/* Multi Select */}
            <div>
              <Select
                value={selectedReasons}
                isMulti
                onChange={(e) => setSelectedReasons(e)}
                placeholder="Select an option"
                options={options}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: '#282828',
                    borderColor: 'gray',
                    color: 'white',
                    boxShadow: 'none',
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#282828',
                    border: '1px solid gray',
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused ? '#333' : '#282828',
                    color: 'white',
                    cursor: 'pointer',
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: 'orange',
                    borderRadius: '6px',
                    padding: '2px 6px',
                  }),
                  multiValueLabel: (base) => ({
                    ...base,
                    color: 'white',
                    fontSize: '13px',
                  }),
                  multiValueRemove: (base) => ({
                    ...base,
                    color: 'white',
                    ':hover': { backgroundColor: '#c53030', color: 'white' },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: 'gray',
                  }),
                }}
              />
            </div>

            {/* Textarea */}
            <div>
              <p className="m-0 p-0">Free Type</p>
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                rows={4}
                className="w-100 rounded"
                style={{
                  backgroundColor: '#151515',
                  color: 'white',
                  border: '1px solid gray',
                  padding: '10px',
                  outline: 'none',
                }}
              />
            </div>
          </div>
        </CModalBody>

        {/* Footer */}
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '0 0 10px 10px  ',
          }}
          className="pt-2"
        >
          <CButton
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={handleSubmit}
          >
            {isAddingRos ? 'Saving...' : 'Save'}
          </CButton>
          <CButton
            style={{
              backgroundColor: '#333',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            onClick={() => {
              setVisible(false)
              setSelectedReasons([])
              setText('')
            }}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ProviderRosTab

// reviewOfSystem
// : 
// {editROS: '14 pt ros was done and patient denies\nrishi', rosOption: Array(1), freeType: 'rishi'}